export enum NAMES {
	PROVIDERS = 'providers',
	XLS = 'xls',
	NOT_JOINED = 'Not Joined',
}
